import axios from '@/libs/axios'

export default {
  current: () => axios.get('/team/statistics/count'),
  downtimeCostsByDay: month => axios.get(`/team/statistics/downtime-costs-by-day/${month}`),
}
